import { useStores } from '@/utils/hooks/useStores';
import { Button } from 'antd';
import React from 'react';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const QuestionButton = () => {
    const {
        modalsStore: { openQuestionForm },
    } = useStores();
    const LOCALIZATION = useLocalization();
    return (
        <Button
            onClick={() => openQuestionForm()}
            style={{ maxWidth: '316px', width: '100%', height: '36px' }}
        >
            {LOCALIZATION.pages.help.buyers.haventFoundAnswer}
        </Button>
    );
};

export default QuestionButton;
